import React, {
  useCallback,
  useEffect,
  useState,
  useLayoutEffect,
} from 'react';
import { withTranslation } from 'react-i18next';
import { compose } from 'recompose';
import { inject, observer } from 'mobx-react';
import {
  DesktopMenu,
  Flex,
  Header,
  HeaderNavItem,
  MySelectStyle,
  SubHeader,
  SubHeaderItem,
} from './style';
import GainersAndLosers from './AnalyticCharts/GainersAndLosers';
import AreaChart from './AnalyticCharts/AreaChart';
import OrderList from './OrderList/OrderList';
import OpenTradingPositions from './AnalyticCharts/OpenTradingPositions';

const AnalyticsRaw = ({ AnalyticsStore }) => {
  const [mode, setMode] = useState('Forex Majors');
  const [periodMode, setPeriodMode] = useState('W1');
  const [instrument, setInstrument] = useState('');
  const periodModeOptions = { D1: 'DAY', W1: 'WEEK', MN: 'MONTH' };

  useEffect(() => {
    (async () => {
      try {
        AnalyticsStore.reset();
        const data = await AnalyticsStore.setData(periodMode, mode);
        await AnalyticsStore.setChartData(
          instrument || data[0].instrument,
          periodMode,
        );
        if (!instrument) setInstrument(data[0].instrument);
      } catch (e) {
        console.error(e);
      }
    })();
  }, [periodMode, mode]);

  useLayoutEffect(() => {
    window.parent.postMessage(
      `rw_height:${window.document.body.scrollHeight}`,
      '*',
    );

    window.addEventListener('resize', (event) => {
      window.parent.postMessage(
        `rw_height:${window.document.body.scrollHeight}`,
        '*',
      );
    });
  }, []);

  const handleChangeMode = useCallback(
    (newMode) => () => {
      setInstrument(null);
      setMode(newMode);
    },
    [mode],
  );

  const handleChangePeriodMode = useCallback(
    (newMode) => () => {
      setPeriodMode(newMode);
    },
    [mode],
  );

  const handleChangeInstrument = (inst) => async () => {
    try {
      AnalyticsStore.resetChartData();
      setInstrument(inst);
      await AnalyticsStore.setChartData(inst, periodMode);
    } catch (e) {
      console.error(e);
    }
  };

  return (
    <div>
      <Header>
        <HeaderNavItem
          onClick={handleChangeMode('Forex Majors')}
          isActive={mode === 'Forex Majors'}
        >
          FX Major
        </HeaderNavItem>
        <HeaderNavItem
          onClick={handleChangeMode('Forex Exotic')}
          isActive={mode === 'Forex Exotic'}
        >
          FX Exotic
        </HeaderNavItem>
        <HeaderNavItem
          onClick={handleChangeMode('Forex Minors')}
          isActive={mode === 'Forex Minors'}
        >
          FX Minor
        </HeaderNavItem>
        <HeaderNavItem
          onClick={handleChangeMode('Crypto')}
          isActive={mode === 'Crypto'}
        >
          Cryptos
        </HeaderNavItem>
        <HeaderNavItem
          onClick={handleChangeMode('Commodities')}
          isActive={mode === 'Commodities'}
        >
          Commodities
        </HeaderNavItem>
      </Header>
      <DesktopMenu>
        <MySelectStyle
          isSearchable={false}
          options={[
            { label: 'FX Major', value: 'Forex Majors' },
            { label: 'FX Exotic', value: 'Forex Exotic' },
            { label: 'FX Minor', value: 'Forex Minors' },
            { label: 'Cryptos', value: 'Cryptos' },
            { label: 'Commodities', value: 'Commodities' },
          ].map((symbol) => ({
            value: symbol.value,
            label: symbol.label,
          }))}
          value={{ label: mode }}
          onChange={(ev) => handleChangeMode(ev.value)()}
        />
        <MySelectStyle
          isSearchable={false}
          onChange={(ev) => handleChangePeriodMode(ev.value)()}
          options={[
            // { label: "DAY", value: "D1" },
            { label: 'WEEK', value: 'W1' },
            { label: 'MONTH', value: 'MN' },
          ].map(({ label, value }) => ({
            value,
            label,
          }))}
          value={{ label: periodModeOptions[periodMode] }}
        />
      </DesktopMenu>
      <SubHeader>
        {/* <SubHeaderItem onClick={handleChangePeriodMode("D1")} isActive={periodMode === "D1"}>
          DAY
        </SubHeaderItem> */}
        <SubHeaderItem
          onClick={handleChangePeriodMode('W1')}
          isActive={periodMode === 'W1'}
        >
          WEEK
        </SubHeaderItem>
        <SubHeaderItem
          onClick={handleChangePeriodMode('MN')}
          isActive={periodMode === 'MN'}
        >
          MONTH
        </SubHeaderItem>
      </SubHeader>
      <Flex>
        <GainersAndLosers data={AnalyticsStore.getData} />
        <AreaChart data={AnalyticsStore.getChartData} />
      </Flex>
      <Flex reversInMobile>
        <OpenTradingPositions data={AnalyticsStore.getData} />
        <OrderList
          instrument={instrument}
          handleChangeInstrument={handleChangeInstrument}
          data={AnalyticsStore.getData}
        />
      </Flex>
    </div>
  );
};

export const Analytics = compose(
  inject('AnalyticsStore'),
  withTranslation(),
)(observer(AnalyticsRaw));
